module.exports = __webpack_public_path__ + "img/IMG_3945_L_BlackMatted_MockedUp.c06a2f44.jpg";